import React from 'react';

import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Paper, Stack, Typography } from '@mui/material';

import ChangeSummary from './ChangeSummary';
import ProseValuePanel from './ProseValuePanel';
import ValuePanel from './ValuePanel';
import type { DisplayChange } from './types';

interface Props {
  change: DisplayChange;
  showPrevious: boolean;
}

export default function FullChangeCard({ change, showPrevious }: Props) {
  if (change.isLongText) {
    return (
      <Paper variant="outlined" sx={{ p: 2, borderRadius: 1.5 }}>
        <Stack spacing={1.25}>
          <Stack spacing={0.5}>
            <Typography variant="subtitle2" fontWeight={700}>
              {change.label}
            </Typography>
            <ChangeSummary change={change} showPrevious={showPrevious} />
          </Stack>
          {showPrevious && <ProseValuePanel label="Before">{change.oldDisplay}</ProseValuePanel>}
          <ProseValuePanel label="After">{change.newDisplay}</ProseValuePanel>
        </Stack>
      </Paper>
    );
  }

  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 1.5 }}>
      <Stack spacing={1.25}>
        <Stack spacing={0.5}>
          <Typography variant="subtitle2" fontWeight={700}>
            {change.label}
          </Typography>
          <ChangeSummary change={change} showPrevious={showPrevious} />
        </Stack>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.25} alignItems="stretch">
          {showPrevious && <ValuePanel label="Before">{change.oldDisplay}</ValuePanel>}
          {showPrevious && <ArrowForwardIcon sx={{ alignSelf: 'center', color: 'text.disabled' }} />}
          <ValuePanel label="After">{change.newDisplay}</ValuePanel>
        </Stack>
      </Stack>
    </Paper>
  );
}
